// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"SideBar_mainContainer__2VIc5","logoContainer":"SideBar_logoContainer__1pkvw","navContainer":"SideBar_navContainer__23JdW"};